<template>
	<div>
		<v-row dense>
			<v-col cols="12" sm="12" md="12" lg="12" xl="12">
				<div v-if="!isOrganizationItemLoading">
					<organization-form-4-person :disabled="!editMode" v-model="organizationItem" />
				</div>
				<div v-else>
					<v-progress-linear indeterminate></v-progress-linear>
				</div>
			</v-col>
		</v-row>
		<v-row dense v-if="editMode">
			<v-col cols="12" sm="12" md="12" lg="12" xl="12">
				<standard-actions save cancel @save="save" @cancel="cancel" />
			</v-col>
		</v-row>
		<v-row dense v-else>
			<v-col cols="12" sm="12" md="12" lg="12" xl="12">
				<l-tooltip right>
					<template v-slot:activator="{ on, attrs }">
						<v-btn v-bind="attrs" v-on="on" @click="enableEditMode" small :retain-focus-on-click="false">
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
					</template>
					<span>{{ $t('$global.actions.edit') }}</span>
				</l-tooltip>
			</v-col>
		</v-row>
	</div>
</template>

<script>
// globals
// locals
import i18n from './dictionary';
// models
import { Organization } from '@/plugins/clientModels';
// components
import OrganizationForm4Person from '@/components/models/editorForms/organizationForm/OrganizationForm4Person.vue';
import StandardActions from '@/components/base/standardActions/StandardActions.vue';
import LTooltip from '@/components/base/LTooltip.vue';

export default {
	name: `OrganizationTab`,
	components: { OrganizationForm4Person, StandardActions, LTooltip },
	mixins: [],
	i18n,
	props: {},
	data() {
		return {
			organizationItem: () => {
				return;
			},
			isOrganizationItemLoading: false,
			isOrganizationItemLoadingError: false,
			editMode: false,
			tempItem: () => {
				return;
			},
		};
	},
	created() {
		this.$options.Organization = Organization;
		this.loadOrganizationItem();
	},
	methods: {
		loadOrganizationItem() {
			return new Promise((resolve, reject) => {
				this.isOrganizationItemLoading = true;
				this.$options.Organization.getById({
					_id: '000000000000000000000000', //own COmpany ObjectId('000000000000000000000000') fullName: 'CM'
					optionName: this.optionName ? this.optionName : 'none',
				})
					.then((result) => {
						this.organizationItem = result;
						this.organizationItem.address.country =
							this.organizationItem.address.country.length >= 1 ? this.organizationItem.address.country.length : 'AT';
					})
					.catch((error) => {
						this.organizationItem = {};
						this.isOrganizationItemLoadingError = error;
						reject(error);
					})
					.finally(() => {
						this.isOrganizationItemLoading = false;
						resolve(this.organizationItem);
					});
			});
		},
		enableEditMode() {
			this.tempItem = this.$_.cloneDeep(this.organizationItem);
			this.editMode = true;
		},
		cancel() {
			this.organizationItem = this.$_.cloneDeep(this.tempItem);
			this.editMode = false;
		},
		async save() {
			const savedItem = await this.organizationItem.save({
				optionName: 'full',
			});
			this.organizationItem = this.$_.cloneDeep(savedItem);
			this.editMode = false;
		},
	},
};
</script>
